import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import { SystemPickerField } from '../fields/SystemPicker';
import {
  systemPickerUiOptionsSchema,
  systemPickerValueSchema,
} from '../schemas/systemPickerSchema';

export const systemPickerFieldExtension: any = FormFieldBlueprint.make({
  name: 'system-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'SystemPicker',
        component: SystemPickerField,
        schema: makeFieldSchema({
          output: () => systemPickerValueSchema,
          uiOptions: () => systemPickerUiOptionsSchema,
        }),
      }),
  },
});
